export const selectedFolderNodeScreenReaderOnlyText = "ZG1NAd";
export const ellipsesButtonTitle = "XWYZq";
export default {selectedFolderNodeScreenReaderOnlyText,ellipsesButtonTitle};